<template>
  <div
    class="alert alert-danger mt-3 mb-0 mx-4 py-3"
    role="alert"
    v-if="props.methodError"
  >
    <i class="fas fa-exclamation-circle"></i>
    &nbsp;Error
    <hr />
    <p v-if="props.partialSuccess && Array.isArray(props.methodError)">
      Purchase has been partially applied. Please note that the following products failed to be applied to your account. You have not been charged for them.
      <br />
      <br />
      <span v-for="err in props.methodError" :key="err.planCode">{{ formatPlanCode(err.planCode) }}: {{ err.err }}</span>
    </p>

    <!--
      paypal users in india (for example) can't purchase renewing subscriptions so we need to
      inform them about our non-renewing subscriptions. this is done when pi sends us an
      `alternatePlanCode` with an error
    -->
    <div v-else-if="paymentState.purchaseFailed && props.methodError && props.methodError && typeof props.methodError === 'object' && !Array.isArray(props.methodError)">
      <p>
        Unable to process purchase:
        <br />
        <br />
        {{ displayName }} Error:
        <span v-if="props.methodError.alternatePlanCode">
          {{ props.methodError.text }}
          <!-- we don't have a non renewing option for dedis so we set the qty to 0 and prompt the cart to display a warning -->
          <router-link
            :to="{ name: 'CheckoutCart', query: {
              ...Object.fromEntries(Object.entries(route.query).filter(([k]) => k !== 'servers')),
              ...(route.query.servers && { 'removed-servers': 1 }),
              plan: props.methodError.alternatePlanCode
            } }"
          >
            here
          </router-link>
          .
        </span>
        <br />
        <br />
        If this error persists, please contact
        <a href="support@speedify.com">support@speedify.com</a>
      </p>
    </div>

    <div v-else-if="paymentState.purchaseFailed && props.methodError">
      <p>
        Unable to process purchase:
        <br />
        {{ displayName }} Error: <span>{{ props.methodError }}</span>
        <br />
        If this error persists, please contact
        <a href="support@speedify.com">support@speedify.com</a>
      </p>
    </div>

    <p v-else-if="typeof props.methodError === 'string'">
      {{ props.methodError }}
    </p>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { useCheckoutStore } from '@/stores/checkout';
import { formatPlanCode } from '@/services/backend';

const { paymentState } = useCheckoutStore();
const route = useRoute();

const props = defineProps({
  paymentMethodName: {
    type: String,
    required: true,
  },
  methodError: {
    type: [Array, String, Object],
    required: false,
  },
  partialSuccess: {
    type: Boolean,
    required: true,
  },
});

const displayName = computed(() => {
  const nameMap = {
    'googlepay': 'Google Pay',
    'paypal': 'PayPal',
    'applepay': 'Apple Pay',
    'venmo': 'Venmo',
    'creditCard': 'Credit Card'
  };
  return nameMap[props.paymentMethodName] || props.paymentMethodName;
});
</script>
